import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as bootstrap from 'bootstrap';

@Component({
  selector: 'add-citizen-profile',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './citizen-profile.component.html',
  styleUrl: './citizen-profile.component.css'
})
export class CitizenProfileComponent {

  activeTab: string = 'posts'; // Default tab is "Timeline"

  @Input() data: any = {
    data: [
       {
        name: "Vishal Aher",
        mobile: "+917055223388",
        email: "raveeshrjaput@gmail.com",
        type: "Citizen",
        profilePicture: "https://images.pexels.com/photos/326055/pexels-photo-326055.jpeg?auto=compress&cs=tinysrgb&w=600",
        address: {
          location: "Kalewadi",
        }
       }
      ]
  };

  @Input() config: any = { 
    config: {
  wrapperClass: 'wrapper',
  containerClass: 'container mt-4',
  rowClass: 'row news-card shadow-lg p-3 bg-white rounded',
  leftImageClass: 'col-lg-4 d-none d-lg-block',
  imageClass: 'news-image img-fluid rounded',
  cardClass: 'col-lg-8 col-12',
  authorClass: 'd-flex align-items-center mb-2',
  profileClass: 'profile-img me-2 img-fluid rounded-circle w-25 h-25 object-fit-cover',
  profileButtonClass: 'btn',
  textClass: 'text-muted fw-bold mb-1',
  dateClass: 'text-muted small mb-0',
  statusButtonClass: 'btn btn-outline-secondary btn-sm ms-auto share-btn',
  shareButtonClass: 'btn btn-outline-warning btn-sm ms-2',
  mobileImageClass: 'd-lg-none text-center mb-3',
  titleClass: 'fw-bold',
  descriptionClass: 'text-muted',
  tagsClass: 'mb-2',
  badgeClass: 'badge text-black me-1',
  reactionClass: 'd-flex align-items-center mb-2',
  likeButtonClass: 'btn btn-light btn-sm me-2',
  dislikeButtonClass: 'btn btn-light btn-sm me-2',
  commentButtonClass: 'btn btn-light btn-sm',
  modalClass: 'modal fade',
  modalDialogClass: 'modal-dialog modal-dialog-centered modal-lg',
  modalContentClass: 'modal-content',
  modalBodyClass: 'modal-body text-center',
  modalImageClass: 'img-fluid rounded',
  modalFooterClass: 'modal-footer',
  closeButtonClass: 'btn btn-primary',
  useIcons: true,
  profileDetailsClass: 'd-flex flex-column',
    }
};

filteredPosts: any[] = [];
filteredIssues: any[] = [];
filteredAnnouncements: any[] = [];
currentUserId: string = "123"; // Replace with actual logged-in user ID

  ngOnInit(): void {
    if (typeof this.data === 'string') {
      this.data = JSON.parse(this.data);
    }
    if (typeof this.config === 'string') {
      this.config = JSON.parse(this.config);
    }

    this.filterUserPosts();
  }

  // Function to filter posts, issues, and announcements based on the logged-in user
  filterUserPosts() {
    const userPosts = this.data.posts || [];
    this.filteredPosts = userPosts.filter((Post: { userId: string; }) => Post.userId === this.currentUserId);
    
    const userIssues = this.data.issues || [];
    this.filteredIssues = userIssues.filter((Issue: { userId: string; }) => Issue.userId === this.currentUserId);
  }

  selectedImage: string = '';
  services: any;

  setActiveTab(tab: string) {
    this.activeTab = tab;
  }

  openModal(image: string) {
    this.selectedImage=''
    console.log("Model Imagee", image,this.selectedImage)
    this.selectedImage = image;
    const modalElement = document.getElementById('imageModal');
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
    }
  }

  likePost(post: any) {
    alert("Liked: " + post.title);
  }
}
